import axios from "utils/axios";

export const createNps = (data) => {
  return axios.post(`/hr/nps`, data);
};

export const ignoreNps = () => {
  return axios.patch(`/hr/nps/ignore`);
};
